import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import ActionInputs from './ActionInputs';

export default function ActionInputsWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper Component={ActionInputs} {...props} />
  );
}
